<emoji-mart
            emoji="point_up"
            (emojiSelect)="onEmojiSelect($event)"
            [darkMode]="false"
            color="#ff5f00"
            [emojiTooltip]="false"
            [isNative]="true"
            [showPreview]="false">
</emoji-mart>
